import React from 'react'

const MultiPlayerPage = () => {
    return (
        <div style={{display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center", height:"100vh"}}>
            <h1>Multiplayer coming soon</h1>
            <h2>Sign IN Required to play Multiplayer</h2>
        </div>
    )
}

export default MultiPlayerPage
